import { api } from './api';

export const promptsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPrompts: builder.query({
      query: (params = {}) => {
        const { page = 1, limit = 50, search } = params;
        const queryParams = {
          page,
          limit,
          type: 2,
          ...(search && { search }),
          ...(params.needs_metadata === true && { needs_metadata: 'true' }),
        };
        return { url: '/admin/prompts', params: queryParams };
      },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'Prompt', id })),
              { type: 'Prompt', id: 'LIST' },
            ]
          : [{ type: 'Prompt', id: 'LIST' }],
    }),
    /**
     * Queue a background import for an admin-created prompt.
     * Body shape: { prompt: string, imageUrls: string[], model?: string, categoryIds?: number[] }
     */
    queuePromptImport: builder.mutation({
      query: (body) => ({
        url: '/admin/prompts/queue-import',
        method: 'POST',
        body,
      }),
    }),
    deletePrompt: builder.mutation({
      query: (id) => ({
        url: `/admin/prompts/${id}`,
        method: 'DELETE',
      }),
    }),
    updateCommunityImageTitle: builder.mutation({
      query: ({ id, title }) => ({
        url: `/admin/prompts/community-images/${id}/title`,
        method: 'PATCH',
        body: { title },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Prompt', id },
        { type: 'Prompt', id: 'LIST' },
      ],
    }),
    regeneratePromptTitle: builder.mutation({
      query: (id) => ({
        url: `/admin/prompts/${id}/regenerate-title`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Prompt', id },
        { type: 'Prompt', id: 'LIST' },
      ],
    }),
    regeneratePromptTitlesBulk: builder.mutation({
      query: (ids) => ({
        url: '/admin/prompts/regenerate-title',
        method: 'POST',
        body: { ids },
      }),
      invalidatesTags: [{ type: 'Prompt', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetPromptsQuery,
  useQueuePromptImportMutation,
  useDeletePromptMutation,
  useUpdateCommunityImageTitleMutation,
  useRegeneratePromptTitleMutation,
  useRegeneratePromptTitlesBulkMutation,
} = promptsApi;

